const doc = [({"en":({"js":({"admin":({"highscore_generation_surveys":({"show":({"survey_in_highscore":"%{survey_name} in %{highscore_name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;